module.exports = __webpack_public_path__ + "Roboto-ThinItalic.woff2?5b4a33e176ff736a74f0ca2dd9e6b396";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/ThinItalic/Roboto-ThinItalic.woff2?v=2.137
// module id = 683
// module chunks = 7